import { render, staticRenderFns } from "./OrderedList.vue?vue&type=template&id=64e5ad11"
import script from "./OrderedList.vue?vue&type=script&lang=js"
export * from "./OrderedList.vue?vue&type=script&lang=js"
import style0 from "./OrderedList.vue?vue&type=style&index=0&id=64e5ad11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports